import fetch from './fetch';

// 基础数据-打折理由
const getDiscount = params => fetch({ url: '/discount_reason', params });
const adDiscount = params => fetch({ url: '/discount_reason', params, methold: 'post' });
const controlDiscount = ({ methold, id, params }) => fetch({ url: `/discount_reason/${id}`, methold, params });
const activateDiscount = ({ id }) => fetch({ url: `/discount_reason/${id}/activate`, methold: 'patch' });
const deactivateDiscount = ({ id }) => fetch({ url: `/discount_reason/${id}/deactivate`, methold: 'patch' });

// 基础数据-教学楼管理
const getBuilding = params => fetch({ url: '/building', params });
const addBuilding = params => fetch({ url: '/building', params, methold: 'post' });
const queryBuilding = ({ query }) => fetch({ url: '/building/query', params: { name: query } });
const controlBuilding = ({ methold, id, params }) => fetch({ url: `/building/${id}`, methold, params });
const activateBuilding = ({ id }) => fetch({ url: `/building/${id}/activate`, methold: 'patch' });
const deactivateBuilding = ({ id }) => fetch({ url: `/building/${id}/deactivate`, methold: 'patch' });

// 基础数据-教室管理
const getRoom = params => fetch({ url: '/classroom', params });
const addRoom = params => fetch({ url: '/classroom', params, methold: 'post' });
const controlRoom = ({ methold, id, params }) => fetch({ url: `/classroom/${id}`, methold, params });
const activateRoom = ({ id }) => fetch({ url: `/classroom/${id}/activate`, methold: 'patch' });
const deactivateRoom = ({ id }) => fetch({ url: `/classroom/${id}/deactivate`, methold: 'patch' });
const getRoomUseDetail = ({ params, id }) => fetch({ url: `/use_condition/${id}`, params });
const getRoomExport = params => fetch({ url: '/use_condition_export', params, methold: 'get', isFull: true, config: { responseType: 'blob' } });

// 基础数据-项目管理
const special = ({ params, methold }) => fetch({ url: '/specialized_subject', params, methold });
const activateSpecial = ({ id }) => fetch({ url: `/specialized_subject/${id}/activate`, methold: 'patch' });
const deactivateSpecial = ({ id }) => fetch({ url: `/specialized_subject/${id}/deactivate`, methold: 'patch' });
const controlSpecial = ({ id, methold, params }) => fetch({ url: `/specialized_subject/${id}`, methold, params });
const specialRoot = params => fetch({ url: '/specialized_subject/root', params });
const getSpecialChild = params => fetch({ url: `/specialized_subject/${params.parent_id}/child`, params });
// 基础数据-级别管理
const getGrade = params => fetch({ url: '/fee_level', params });
const grade = ({ params, methold }) => fetch({ url: '/fee_level', params, methold });
const activateGrade = ({ id }) => fetch({ url: `/fee_level/${id}/activate`, methold: 'patch' });
const deactivateGrade = ({ id }) => fetch({ url: `/fee_level/${id}/deactivate`, methold: 'patch' });
const controlGrade = ({ id, methold, params }) => fetch({ url: `/fee_level/${id}`, methold, params });
const gradeRoot = () => fetch({ url: '/fee_level/root' });
const searchOrg = params => fetch({ url: '/org/query', params });
const searchSpecial = params => fetch({ url: '/specialized_subject/query', params });
// 基础数据-组织机构
const structureTree = ({ params, methold }) => fetch({ url: '/org', params, methold });
const controlStructure = ({ id, params, methold }) => fetch({ url: `/org/${id}`, params, methold });
const controlStructureSpecial = ({ id, params, methold }) => fetch({ url: `/org_specialized_subject/${id}`, params, methold });
const getTableByOrg = ({ id, params }) => fetch({ url: `/org/${id}/specialized_subjects/list`, params });
const batchAddSpecialByOrg = ({ org_id, params }) => fetch({ url: `/org/${org_id}/specialized_subjects/upgrade`, params, methold: 'post' });
const batchDelSpecialByOrg = ({ org_id, params }) => fetch({ url: `/org/${org_id}/specialized_subject/remove`, params, methold: 'post' });
const getSpecialByOrg = params => fetch({ url: `/org/${params.org_id}/specialized_subject/query`, params });
const getProvince = () => fetch({ url: '/province' });
const getCity = ({ province_code }) => fetch({ url: `/city/${province_code}` });

const orgOrder = ({ params }) => fetch({ url: '/change_org_order', params, methold: 'post' });
const specializedOrder = ({ params }) => fetch({ url: '/change_specialized_subject_order', params, methold: 'post' });

// 学期管理
const getTermManage = params => fetch({ url: '/term_management', params });
const addTermManage = ({ params, methold }) => fetch({ url: '/term_management', params, methold });
const controlTermMange = ({ params, methold, id }) => fetch({ url: `/update_term/${id}`, params, methold });
// 合同类型
const getContract = params => fetch({ url: '/contract_type_list', params });
const addContract = ({ params, methold }) => fetch({ url: '/contract_type_list', params, methold });
const controlContract = ({ params, methold, id }) => fetch({ url: `/contract_type/${id}`, params, methold });
const activateContract = ({ contract_type_id }) => fetch({ url: `/contract_type/activate/${contract_type_id}`, methold: 'patch' });
const deactivateContract = ({ contract_type_id }) => fetch({ url: `/contract_type/deactivate/${contract_type_id}`, methold: 'patch' });
const exportClassroom = ({ params }) => fetch({
  url: '/export_classroom', params, isFull: true, config: { responseType: 'blob' }
});
const exportClassRoomUse = ({ params }) => fetch({
  url: '/export_class_room_use_condition', isFull: true, params, config: { responseType: 'blob' }
});

const exportSpecializedSubject = () => fetch({
  url: '/export_specialized_subject_list', isFull: true, config: { responseType: 'blob' }
});

const exportFeeLevel = ({ params }) => fetch({
  url: '/export_fee_level', params, isFull: true, config: { responseType: 'blob' }
});

const accessControl = params => fetch({ url: '/access_control_period', params });
const saveAccess = ({ params }) => fetch({ url: '/access_control_period', params, methold: 'post' });

export default {
  exportClassRoomUse,
  exportFeeLevel,
  exportSpecializedSubject,
  exportClassroom,
  activateContract,
  deactivateContract,
  getDiscount,
  adDiscount,
  controlDiscount,
  activateDiscount,
  deactivateDiscount,
  getBuilding,
  addBuilding,
  queryBuilding,
  controlBuilding,
  activateBuilding,
  deactivateBuilding,
  special,
  activateSpecial,
  deactivateSpecial,
  controlSpecial,
  specialRoot,
  getSpecialChild,
  grade,
  getGrade,
  activateGrade,
  deactivateGrade,
  controlGrade,
  gradeRoot,
  structureTree,
  controlStructure,
  controlStructureSpecial,
  getTableByOrg,
  batchAddSpecialByOrg,
  batchDelSpecialByOrg,
  getSpecialByOrg,
  searchOrg,
  searchSpecial,
  getProvince,
  getCity,
  getRoom,
  addRoom,
  controlRoom,
  deactivateRoom,
  activateRoom,
  getRoomUseDetail,
  orgOrder,
  specializedOrder,
  getTermManage,
  addTermManage,
  controlTermMange,
  getContract,
  addContract,
  controlContract,
  accessControl,
  saveAccess,
  getRoomExport
};
